export default function checkExternalLinks() {
    // WOVNのデータを取得するプロミスを作成
    const wovnData = new Promise((resolve, reject) => {
      if (window.WOVN && WOVN.io && WOVN.io.isApiReady()) {
        resolve(WOVN.io.getCurrentLang());
      } else {
        window.addEventListener('wovnApiReady', function () {
          if (WOVN && WOVN.io && WOVN.io.isApiReady()) {
            resolve(WOVN.io.getCurrentLang());
          } else {
            reject(new Error("WOVN API is not ready"));
          }
        });
      }
    });
  
    // リンクチェックの初期化関数
    const initLinkChecker = (lang) => {
      const externalLinks = document.querySelectorAll('.js__external-link');
  
      const langCode = lang.code || null;

      externalLinks.forEach(link => {
        link.addEventListener('click', function(event) {
          event.preventDefault();
          const url = link.href;
          const dataType = link.getAttribute('data-type');
  
          fetch(url, { method: 'HEAD' })
            .then(response => {
              if (response.status >= 400 && response.status < 600) {
                let errorMessage;
                if (dataType === 'image') {
                  errorMessage = `画像を読み込めません: ${url} (エラー: ${response.status})`;
                } else {
                    if( langCode !== null && langCode === "en"){
                        errorMessage = `The Data sheet and UL yellow card are currently experiencing difficulties in accessing the site. We apologize for any inconvenience caused.`;
                    }else if( langCode !== null && langCode == "cn"){
                        errorMessage = `物性参数表和UL黄卡目前在访问网站时遇到困难。我们对由此造成的不便深表歉意。`;
                    }else{
                        errorMessage = `物性表とUL Yellow cardは、ただいまアクセスしにくい状況が発生しております。ご不便をおかけして申し訳ありませんが、しばらく時間をおいて再度アクセスしてください。`;
                    }
                }
                alert(errorMessage);
              } else {
                window.location.href = url;
              }
            })
            .catch(() => {
              alert(`エラー: このリンク先にアクセスできません: ${url}`);
            });
        });
      });
    };
  
    // wovnDataプロミスが解決された後にリンクチェックの初期化を行う
    wovnData.then((lang) => {
  
      if (document.readyState === 'loading') {
        // DOMContentLoadedイベントがまだ発生していない場合
        document.addEventListener('DOMContentLoaded', () => { initLinkChecker(lang); });
      } else {
        // DOMContentLoadedイベントが既に発生している場合
        initLinkChecker(lang);
      }
    }).catch(error => {
      console.error(error);
    });
  }
  